import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/html/dfms-frontend/src/app/forgot-password/components/ForgotPasswordClient.tsx");
